import { PatientWorkflow } from './PatientDetailsPanel'

export const CognitoPatientWorkflow = () => <PatientWorkflow />
